import Cookies from 'js-cookie';

const handler = ( $ ) => {
	$( '#ajax-load-more' ).on( 'click', function ( e ) {
		e.preventDefault();

		const $link = $( '#ajax-load-more' ),
			$postsHolder = $( $link.data( 'posts-holder' ) );
		let offset = $postsHolder.find( 'article' ).length;

		$.ajax( {
			url: themeVars.ajaxUrl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'ajax_load_posts',
				query: $link.attr( 'data-current-query' ),
				query_type: $link.attr( 'data-query-type' ),
				post_type: $link.attr( 'data-post-type' ),
				col_class: $link.attr( 'data-col-class' ),
				offset: offset,
				nonce: Cookies.get( 'wordpress_wom_ajax_nonce' ),
			},
			beforeSend: function () {
				$postsHolder.addClass( 'is-loading' );
			},
			success: function ( answer ) {
				$postsHolder.removeClass( 'is-loading' ).append( answer.html );

				$link.attr(
					'data-current-query',
					JSON.stringify( answer.query )
				);

				if ( answer.hide_link ) {
					$link.hide();
				} else {
					$link.show();
				}
			},
		} );
	} );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
